import { render, staticRenderFns } from "./Narudzbenice.vue?vue&type=template&id=b5811022&"
import script from "./Narudzbenice.vue?vue&type=script&lang=ts&"
export * from "./Narudzbenice.vue?vue&type=script&lang=ts&"
import style0 from "./Narudzbenice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports